import styled from 'styled-components';
import { IFrame } from './interface';

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'flex' : 'none')};
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-template-areas: 'tarifasRecebidasClientes tarifasRecebidas lastTwelveMonths';
  column-gap: 1rem;
  row-gap: 1rem;
  width: 100%;
  margin-top: 0.5rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas: 'tibsReceived  tibsPaid  diference lastTwelveMonths';
  }

  & canvas {
    min-height: 246px !important;
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
